export default __webpack_public_path__ + "static/char-v-41-b402a17c11fcc18dab8a325b415fa1a6.png";